import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	align-items: center;
	grid-template-columns: 42px 1fr;
	margin-top: 32px;
	gap: 16px;
`;

export const Text = styled.p`
	font-size: 12px;
	color: ${tokens.color_gray_dark};

	& > a {
		text-decoration: underline;
		color: ${tokens.color_gray_dark};
		font-weight: 500;
		cursor: pointer;
	}
`;
